import img from '../../../img/sushi1.svg'
import img2 from '../../../img/sushi2.svg'
import img3 from '../../../img/sushi3.svg'
import img4 from '../../../img/sushi4.svg'


export const sushiData = [
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        // isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#1'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#2'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Действительно много семги, сливочный сыр, огурец, рис, н...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#3'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Тигровая креветка, огурец, авокадо, соус Айоли, рис, ик...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#4'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Тигровая креветка, огурец, авокадо, соус Айоли, рис, ик...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#5'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Действительно много семги, сливочный сыр, огурец, рис, н...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#6'
    },
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#7'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sushi#8'
    },


]